// Shared framer-motion presets so liveliness is consistent and disciplined
// across the app. Reduced-motion is honoured globally via <MotionConfig
// reducedMotion="user"> in index.js, so these variants automatically collapse
// to opacity-only (no transforms) for users who prefer reduced motion.

// Gentle fade-up used for section/content reveals.
export const reveal = {
  hidden: { opacity: 0, y: 8 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.28, ease: [0.22, 1, 0.36, 1] },
  },
};

// Container that staggers its children (list rows, board cards, KPI tiles).
export const staggerContainer = (stagger = 0.045, delayChildren = 0.02) => ({
  hidden: {},
  show: { transition: { staggerChildren: stagger, delayChildren } },
});

// Child of a staggerContainer.
export const staggerItem = {
  hidden: { opacity: 0, y: 10 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.3, ease: [0.22, 1, 0.36, 1] },
  },
};

// Scale-in for overlays / popovers (command palette, menus).
export const popIn = {
  hidden: { opacity: 0, scale: 0.97, y: 4 },
  show: { opacity: 1, scale: 1, y: 0, transition: { duration: 0.16, ease: "easeOut" } },
  exit: { opacity: 0, scale: 0.98, transition: { duration: 0.1 } },
};

// Route/page transition — subtle, opacity-led so it can't disturb layout.
export const pageTransition = {
  initial: { opacity: 0, y: 6 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.22, ease: "easeOut" } },
  exit: { opacity: 0, transition: { duration: 0.1 } },
};
